module.exports = __webpack_public_path__ + "img/2.e11d623d.jpg";